import { BamfordEngine } from './game/engine.js'

const canvas = document.getElementById('game-canvas') as HTMLCanvasElement
const hud = document.getElementById('hud') as HTMLElement

if (!canvas || !hud) throw new Error('Required DOM elements missing')

const engine = new BamfordEngine(canvas, hud)

function loop(timestamp: number): void {
  engine.tick(timestamp)
  requestAnimationFrame(loop)
}

requestAnimationFrame(loop)
